import { render, staticRenderFns } from "./register-student.vue?vue&type=template&id=e420cde8&scoped=true&"
import script from "./register-student.vue?vue&type=script&lang=js&"
export * from "./register-student.vue?vue&type=script&lang=js&"
import style0 from "./register-student.vue?vue&type=style&index=0&id=e420cde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e420cde8",
  null
  
)

export default component.exports